import HelpScreen from 'features/auth/help/Help';

export default function HelpPage() {
  return <HelpScreen />;
}
